import { useEffect, useRef, useState } from 'react';

const useScroll = () => {
  const prevScrollPos = useRef(null);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      const isGoingUp =
        currentScrollPos <= 52 ||
        (prevScrollPos.current !== null &&
          prevScrollPos.current >= currentScrollPos);
      setVisible((v) => (isGoingUp !== v ? isGoingUp : v));
      prevScrollPos.current = currentScrollPos;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []); // dépendances vides : listener créé une seule fois

  return visible;
};

export default useScroll;
